/**
 * Promo Code Model
 */

define(function(require, exports, module) {
    'use strict';
    var PortletModel = require('modules/portlet/portlet.model'),
        PromoCodeView = require('portlets/promotion-code/promotion-code.view'),
        server = require('server');

    module.exports = PortletModel.extend({

        validationConfig: {
            promotionCode: {
                required: true
            }
        },

        getView: PromoCodeView,

        sync: function(method, model, options) {
            if (method === 'update') {
                return this.submitCode(model, options);
            }
        },

        /**
         * Submit request for getting bonus by promo code
         * @param  {Model}  model
         * @param  {Object} options
         * @return {Deferred}
         */
        submitCode: function(model, options) {
            return server.send({
                ID: 31065,
                description: 'Apply promo code',
                responses: [31066, 31067],
                promotionCode: model.get('promoCode'),
                triggerType: 'PromotionCode'
            }).done(options.success).fail(options.error);
        }

    });
});